var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('header-menu'),_c('div',{staticClass:"main-body"},[_c('router-view')],1),_c('footer-bottom'),_c('fixed-tools')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }